// src/router/questionario.js

export default [
  {
    path: '/public/questionario/:slug/:usuarioId',
    name: 'Questionario',
    component: () => import('@/views/Questionario/QuestionarioPage.vue'),
    meta: {
      title: 'Questionário',
      layout: 'empty'
    }
  },
  {
    path: '/questionario/:slug/painel',
    name: 'QuestionarioPainel',
    component: () => import('@/views/Questionario/PainelPage.vue'),
    meta: {
      title: 'Painel do questionário',
      breadcrumb: [
        {
          label: 'Home',
          to: 'Home'
        },
        {
          label: 'Painel do questionário',
          to: 'QuestionarioPainel'
        }
      ]
    }
  }
]
